import type C1_EloItem from "../model/C1_EloItem";
import { detachEloItemOutsideOwner } from "../model/C1_detachEloItem";
import { eloRootAndOwner } from "../model/C1_eloOwnerEditing";
import { showToast } from "../../../src/components/Toasts";
import { itx } from "../../../src/translationItx/itx";
import { DisplayNameUsage } from "../../../src/models/BaseObject";

/** Keep UI feedback out of the model and retain the names from before the move. */
export function detachEloItemWithToast(item: C1_EloItem, point: {x: number; y: number}, disabled = false): boolean {
  if (item.interactivCreated) return false;
  const owner = eloRootAndOwner(item)?.owner;
  const room = owner && "room" in owner ? owner.room : undefined;
  if (!owner || !room) return false;
  const names = {"{item}": item.owner?.getDisplayName({usage: DisplayNameUsage.OwnName}) ?? "", "{owner}": owner.owner?.displayName ?? "", "{room}": room.owner?.displayName ?? ""};
  if (!detachEloItemOutsideOwner(item, point, disabled)) return false;
  void showToast({
    text: itx("c1.eloItemDetached", "{item} wurde von {owner} gelöst,\nund dem Raum {room} direkt zugeordnet", names),
  });
  return true;
}
